import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Modal } from "react-bootstrap";
import SearchDateBox from "../../SearchDateBox";
import FilterContext from "../../../routes/FilterContext";
import { connect } from "react-redux";
import {
  noDataForGraph,
  piexceldataFormate,
} from "../../../services/utilities/util";
import { JsonToExcel } from "react-json-to-excel";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ChartExpandModal from "../../../services/utilities/ChartExpandModal";
import { Chart } from "react-google-charts";

function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}

export const options = {
  pieHole: 0.4,
  pieSliceText: "none",
  chartArea: {
    left: 0,
    height: 250,
    width: 600,
  },
  legendTextStyle: {
    color: "black",
    fontSize: "13",
    top: 10,
    left: 50,
    position: "start",
  },
  sliceVisibilityThreshold: 0,
  pieResidueSliceLabel: "Other",
  legend: {
    position: "labeled",
    textStyle: { color: "#000" },
    alignment: "start",
    labeledValueText: "both",
  },
  colors: [
    "#CDA6FF",
    "#B786ED",
    "#A066DC",
    "#8A46CA",
    "#7326B9",
    "#6816B0",
    "#6015AD",
    "#5714A9",
    "#4F13A6",
    "#4612A3",
  ],
};

class LeasedSpaceShareTopAssets extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
    this.state = {
      googlePieChartData: [],
      noGraph: false,
      expandChartKey: Math.random(),
      expandChart: false,
      showLoader: false,
      showGraph: false,
      filters: "",
      isOpen: false,
      start_date: "",
      end_date: "",
      which_date: "",
      which_date_name: "",
      bodyParams: "",
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
      exceldata: [],
      showEllipsis:
        typeof this.props.showEllipsis != "undefined"
          ? this.props.showEllipsis
          : true,
      chartHeightClass:
        typeof this.props.chartHeightClass != "undefined"
          ? this.props.chartHeightClass
          : "col-lg-12 allChartHeight",
    };
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    if (typeof this.props.bodyParams != "undefined") {
      var body = this.props.bodyParams;
    } else {
      var body = new FormData();
      body.append("filter", filters);
    }

    apiMiddleware
      .post("api/edge/office/get_assets_leased_space_share", body)
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        let arr1 = res.data.x;
        let arr2 = res.data.y;
        const result = arr2.map((arr2, i) => [arr2, Number(arr1[i])]);
        result.unshift(["Assets", "Area(msf)"]);
        this.setState({ googlePieChartData: result });
        if (noDataForGraph(res.data.x)) {
          this.setState({
            noGraph: false,
          });
        } else {
          this.setState({
            noGraph: true,
          });
        }

        const excelData = piexceldataFormate(
          res,
          "Leased Space Area(msf)",
          "Assets"
        );

        this.setState({
          exceldata: excelData,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
      } else if (typeof this.props.bodyParams != "undefined") {
        body = this.props.bodyParams;
      }
      this.setState({
        bodyParams: body,
      });

      apiMiddleware
        .post("api/edge/office/get_assets_leased_space_share", body)
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          let arr1 = res.data.x;
          let arr2 = res.data.y;
          const result = arr2.map((arr2, i) => [arr2, Number(arr1[i])]);
          result.unshift(["Assets", "Area(msf)"]);
          this.setState({ googlePieChartData: result });
          if (noDataForGraph(res.data.x)) {
            this.setState({
              noGraph: false,
            });
          } else {
            this.setState({
              noGraph: true,
            });
          }
          const excelData = piexceldataFormate(
            res,
            "Leased Space Area(msf)",
            "Assets"
          );

          this.setState({
            exceldata: excelData,
          });
        });
    }
  }

  downloadPdf() {
    const input = document.getElementById("leasedSpaceShareTopAssets");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("leasedSpaceShareTopAssets.pdf");
    });
  }

  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => this.setState({ isOpen: false });

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    data.dateType = this.state.which_date;
    data.dateTypeName = this.state.which_date_name;
    return (
      <div className="widget widgetGraph" id="leasedSpaceShareTopAssets">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {!this.state.showLoader && this.state.noGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Leased Space Share (msf) - Top 10 Assets</p>
              {this.state.start_date.length > 0 &&
                this.state.end_date.length > 0 &&
                this.state.start_date != "ull" && (
                  <p className="dateFont">
                    {this.state.start_date} To {this.state.end_date}
                  </p>
                )}
            </div>
            <div className="col-lg-3 text-end">
              {this.state.showEllipsis && (
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.openModal();
                      }}
                    >
                      Select Date Range
                    </li>
                  </ul>
                </p>
              )}
            </div>
            <div className="col-lg-12 text-center">
              <img src="/edge/images/NoGraph-01.png" className="w100" />
            </div>
          </div>
        )}
        {this.state.showGraph && !this.state.noGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Leased Space Share [msf,(%)] - Top 10 Assets</p>
              {this.state.start_date.length > 0 &&
                this.state.end_date.length > 0 &&
                this.state.start_date != "ull" && (
                  <p className="dateFont">
                    {this.state.start_date} To {this.state.end_date}
                  </p>
                )}
            </div>
            <div className="col-lg-3 text-end">
              {this.state.showEllipsis && (
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.downloadPdf();
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "pdf_download");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append(
                          "screen_sub_type",
                          "leased Space Share Top Assets"
                        );
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {});
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                    </li>

                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "excel_export");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append(
                          "screen_sub_type",
                          "leased Space Share Top Assets"
                        );
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <JsonToExcel
                        title="Download as Excel"
                        data={this.state.exceldata}
                        fileName="leasedSpaceShareTopAssets"
                        btnClassName="graphExcelDownloadBtn"
                      />
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.openModal();
                      }}
                    >
                      Select Date Range
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.setState({
                          expandChart: true,
                          expandChartKey: Math.random(),
                        });
                      }}
                    >
                      Expand Chart
                    </li>
                  </ul>
                </p>
              )}
            </div>
            <div className={this.state.chartHeightClass}>
              <Chart
                chartType="PieChart"
                data={this.state.googlePieChartData}
                options={options}
                width={"100%"}
                height={"450px"}
              />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-12 chartSearchBox">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              className="columnsModal selectColumn downloadImgModal chartModal"
              size="lg"
            >
              <Modal.Body>
                <SearchDateBox
                  datechildFilter={this.dateFilter}
                  parentData={data}
                />
              </Modal.Body>
            </Modal>
          </div>
        </div>
        <ChartExpandModal
          openModal={this.state.expandChart}
          chartName={LeasedSpaceShareTopAssets}
          key={this.state.expandChartKey}
          filters={this.state.filters}
          chartHeightClass={"col-lg-12"}
          bodyParams={this.state.bodyParams}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(LeasedSpaceShareTopAssets);
